import Spin from 'components/spin';
import FilterComponent from './filter';
import { toast } from 'react-toastify';
import { CiFilter } from 'react-icons/ci';
import styles from './search.module.scss';
import policyService from 'services/policy';
import useDebounce from 'hooks/useDebounce';
import { useNavigate } from 'react-router-dom';
import { setSearch } from 'redux/slices/search';
import { useQuery } from '@tanstack/react-query';
import { Badge, Box, Button } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { ErrorResponse } from 'interfaces/global.types';
import { IoCloseSharp, IoSearch } from 'react-icons/io5';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

export default function DebounceSearch() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectRef = useRef<any>(null);
  const [state, setState] = useState('');
  const [searchVal, setSearchVal] = useState('');
  const [show, setShow] = useState(false);
  const debouncedValue = useDebounce(state, 400);
  const [fillterModal, setFilterModal] = useState<any>(null);
  const { search, type } = useSelector((state: any) => state.search, shallowEqual);

  const handleChange = (event: any) => {
    setSearchVal(event.target.value);
  };

  const handleKey = (event: any) => {
    if (event.key === 'Enter') {
      setState(searchVal);
      setShow(true);
    }
  };
  const param: any = {
    type: type,
    search: debouncedValue ? debouncedValue : undefined,
  };

  const FilterModalOpen = Boolean(fillterModal);

  const openFilterModal = (event: React.MouseEvent<HTMLButtonElement>) =>
    setFilterModal(event.currentTarget);

  const { isLoading, data, error }: any = useQuery({
    queryKey: ['policy_getAll', debouncedValue, type],
    queryFn: () => policyService.getAll(param),
    onError: (error: ErrorResponse) => toast.error(error?.data?.detail),
    enabled: Boolean(debouncedValue && type),
  });

  const dataItems = Array.isArray(data?.results) ? data.results : [];
  const errorMessage = error?.data?.detail || 'Ошибка поиска';

  const handleClear = () => {
    setState('');
    dispatch(setSearch({ results: [] }));
  };

  useEffect(() => {
    const results = Array.isArray(search?.results) ? search.results : [];

    if (results.length === 0) {
      setState('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handleClickOutside = (e: any) => {
    if (!selectRef.current.contains(e.target)) {
      return setShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Box position='relative' ref={selectRef}>
      <Box className={styles.search}>
        <Button
          onClick={(e: any) => {
            e.stopPropagation();
            openFilterModal(e);
          }}
          className={styles.filter}>
          {type !== 'all' ? (
            <Badge color='error' variant='dot'>
              <CiFilter className={styles.filterIcon} />
            </Badge>
          ) : (
            <CiFilter className={styles.filterIcon} />
          )}
        </Button>
        <input
          type='text'
          className={styles.autocomplete}
          placeholder='Поиск'
          autoComplete='off'
          value={searchVal}
          onChange={handleChange}
          onKeyUp={handleKey}
        />
        {state.length > 0 ? (
          <IoCloseSharp className={styles.clearIcon} onClick={handleClear} />
        ) : (
          <IoSearch className={styles.searchIcon} />
        )}
      </Box>
      <Box className={styles.dropdown} display={!show ? 'none' : 'block'}>
        {!show ? null : isLoading ? (
          <Box className={styles.loadBox}>
            <Spin size='20px' />
          </Box>
        ) : error ? (
          <Box className={styles.loadBox}>{errorMessage}</Box>
        ) : dataItems.length === 0 ? (
          <Box className={styles.loadBox}>Нет результатов поиска</Box>
        ) : (
          <table className={styles.table}>
            <tbody>
              {dataItems.map((item: any) => (
                <tr
                  key={item?.id}
                  onClick={() => {
                    dispatch(setSearch({ results: [item] }));
                    setState('');
                    navigate('/maintenance-policies');
                    setShow(false);
                  }}>
                  <td>{item?.last_name + ' ' + (item?.first_name || '')}</td>
                  <td>№ {item.policy_number}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Box>
      {fillterModal && (
        <FilterComponent
          setShow={setShow}
          open={FilterModalOpen}
          anchorEl={fillterModal}
          close={() => setFilterModal(null)}
        />
      )}
    </Box>
  );
}
